import RouteDetail from '@/controllers/route/route-detail.js';
import CONFIG from "@/assets/js/config.custom.js";
import axios from "axios";

export default {
  extends: RouteDetail,

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isLoading: true,
    };
  },

  computed: {
    hasRouteData() {
      return !!(this.routeData && this.routeData.id != null);
    },
  },

  watch: {
    '$route.params.id'(newId, oldId) {
      if (oldId !== undefined && newId !== oldId) {
        this.loadRouteDetail();
      }
    },
  },

  methods: {
    loadRouteDetail() {
      this.isLoading = true;
      this.routeData = {};
      this.routePoint = [];
      this.routePoint_status = null;
      this.getDetail();
      this.routePointByRoute();
    },

    /**
     * Override: clear routeData when missing/invalid so noDataMsg can show
     */
    getDetail() {
      axios.get(`route/detail/${this.$route.params.id}`, {
        params: { campus_id: this.$store.state.user.campus_id },
      })
        .then((res) => {
          const data = res.data?.data;
          if (data && data.id != null) {
            this.routeData = data;
          } else {
            this.routeData = {};
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response?.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.routeData = {};
          this.isLoading = false;
        });
    },
  },
};
